/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
  AppealsState,
  AppealsReportItem,
  AppealsReportViewState,
} from "@modules/reporting/reducer/reports/appeals/types";
import { getPagination } from "@selectors";
import type { PaginationExtendedType } from "@types";

export const getAppeals = (state: State): AppealsState => {
  return state.reporting.reports.appeals;
};

export const defaultReports = (state: State): Array<DefaultReports> =>
  getAppeals(state).defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> =>
  getAppeals(state).mySavedReports;

export const getReportData = (state: State): Array<AppealsReportItem> =>
  getAppeals(state).reportData.content;

export const getReportDataPagination = (state: State): PaginationExtendedType =>
  getPagination(getAppeals(state).reportData);

export const getReportDataPage = (state: State): number | null =>
  getReportDataPagination(state).pageNumber;

export const getCurrentReport = (state: State): ?Object =>
  (getAppeals(state).currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object => getAppeals(state).currentCharts;

export const getAppealsFiltersSchema = (state: State): ?Object =>
  getAppeals(state).appealsFiltersSchema;

export const getAppealReasons = (state: State): Array<string> => getAppeals(state).appealReasons;

export const getReportToSave = (state: State): ?Object => getAppeals(state).reportToSave;

export const getViewState = (state: State): AppealsReportViewState => getAppeals(state).viewState;

export const isLoading = (state: State): boolean => getAppeals(state).requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean =>
  getAppeals(state).reportGenerateInProgress > 0;
